import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { merge } from 'carbon-components-angular/utils';
import * as i1 from 'carbon-components-angular/i18n';
import { I18nModule } from 'carbon-components-angular/i18n';
import * as i2 from 'carbon-components-angular/experimental';
import { ExperimentalModule } from 'carbon-components-angular/experimental';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i4$1 from 'carbon-components-angular/icon';
import { IconModule } from 'carbon-components-angular/icon';
import * as i6 from 'carbon-components-angular/forms';
import { ButtonModule } from 'carbon-components-angular/forms';
import { range } from 'carbon-components-angular/common';
function Pagination_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "p", 4)(2, "p", 5)(3, "p", 6);
    i0.ɵɵelementEnd();
  }
}
function Pagination_div_2_ng_container_1_option_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r9 = ctx.$implicit;
    i0.ɵɵproperty("value", option_r9);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r9, " ");
  }
}
function Pagination_div_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 9);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 10)(5, "select", 11);
    i0.ɵɵlistener("ngModelChange", function Pagination_div_2_ng_container_1_Template_select_ngModelChange_5_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r10 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r10.itemsPerPage = $event);
    });
    i0.ɵɵtemplate(6, Pagination_div_2_ng_container_1_option_6_Template, 2, 2, "option", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(7, "svg", 13);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r4.itemsPerPageSelectId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 9, ctx_r4.itemsPerPageText.subject), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("cds--select--disabled", ctx_r4.pageInputDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r4.itemsPerPageSelectId)("ngModel", ctx_r4.itemsPerPage)("disabled", ctx_r4.pageInputDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r4.itemsPerPageOptions);
    i0.ɵɵadvance();
    i0.ɵɵattribute("ariaLabel", i0.ɵɵpipeBind1(8, 11, ctx_r4.optionsListText.subject));
  }
}
const _c0 = a0 => ({
  "margin-left": a0
});
const _c1 = (a0, a1, a2) => ({
  start: a0,
  end: a1,
  total: a2
});
function Pagination_div_2_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "i18nReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(7, _c0, ctx_r5.showPageInput ? null : 0));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, i0.ɵɵpipeBind2(3, 4, ctx_r5.totalItemText.subject, i0.ɵɵpureFunction3(9, _c1, ctx_r5.startItemIndex, ctx_r5.endItemIndex, ctx_r5.totalDataLength))), " ");
  }
}
function Pagination_div_2_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "i18nReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(7, _c0, ctx_r6.showPageInput ? null : 0));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, i0.ɵɵpipeBind2(3, 4, ctx_r6.totalItemsText.subject, i0.ɵɵpureFunction3(9, _c1, ctx_r6.startItemIndex, ctx_r6.endItemIndex, ctx_r6.totalDataLength))), " ");
  }
}
const _c2 = (a0, a1) => ({
  start: a0,
  end: a1
});
function Pagination_div_2_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "i18nReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(7, _c0, ctx_r7.showPageInput ? null : 0));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, i0.ɵɵpipeBind2(3, 4, ctx_r7.totalItemsUnknownText.subject, i0.ɵɵpureFunction2(9, _c2, ctx_r7.startItemIndex, ctx_r7.endItemIndex))), " ");
  }
}
function Pagination_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, Pagination_div_2_ng_container_1_Template, 9, 13, "ng-container", 7)(2, Pagination_div_2_span_2_Template, 4, 13, "span", 8)(3, Pagination_div_2_span_3_Template, 4, 13, "span", 8)(4, Pagination_div_2_span_4_Template, 4, 12, "span", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showPageInput);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.pagesUnknown && ctx_r1.totalDataLength <= 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.pagesUnknown && ctx_r1.totalDataLength > 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.pagesUnknown);
  }
}
function Pagination_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "p", 4);
    i0.ɵɵelementEnd();
  }
}
function Pagination_div_4_span_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r16.currentPage);
  }
}
function Pagination_div_4_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 24);
    i0.ɵɵtemplate(1, Pagination_div_4_span_1_ng_container_1_Template, 2, 1, "ng-container", 7);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r12.showPageInput);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, ctx_r12.pageText.subject), " ");
  }
}
function Pagination_div_4_ng_container_2_input_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 30);
    i0.ɵɵlistener("ngModelChange", function Pagination_div_4_ng_container_2_input_5_Template_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const ctx_r20 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r20.currentPage = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", ctx_r17.currentPageSelectId)("max", ctx_r17.pageOptions.length)("ngModel", ctx_r17.currentPage);
  }
}
function Pagination_div_4_ng_container_2_select_6_option_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r24 = ctx.index;
    i0.ɵɵproperty("value", i_r24 + 1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i_r24 + 1);
  }
}
function Pagination_div_4_ng_container_2_select_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 31);
    i0.ɵɵlistener("ngModelChange", function Pagination_div_4_ng_container_2_select_6_Template_select_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r26);
      const ctx_r25 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r25.currentPage = $event);
    });
    i0.ɵɵtemplate(1, Pagination_div_4_ng_container_2_select_6_option_1_Template, 2, 2, "option", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", ctx_r18.currentPageSelectId)("disabled", ctx_r18.pageInputDisabled)("ngModel", ctx_r18.currentPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r18.pageOptions);
  }
}
function Pagination_div_4_ng_container_2__svg_svg_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 32);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("ariaLabel", i0.ɵɵpipeBind1(1, 1, ctx_r19.optionsListText.subject));
  }
}
function Pagination_div_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 25)(2, "label", 26);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, Pagination_div_4_ng_container_2_input_5_Template, 1, 3, "input", 27)(6, Pagination_div_4_ng_container_2_select_6_Template, 2, 4, "select", 28)(7, Pagination_div_4_ng_container_2__svg_svg_7_Template, 2, 3, "svg", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("cds--select--disabled", ctx_r13.pageInputDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r13.currentPageSelectId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 7, ctx_r13.pageText.subject));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r13.pageOptions.length > ctx_r13.pageSelectThreshold);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r13.pageOptions.length <= ctx_r13.pageSelectThreshold);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r13.pageOptions.length <= 1000);
  }
}
function Pagination_div_4_span_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r27.currentPage);
  }
}
const _c3 = a0 => ({
  last: a0
});
function Pagination_div_4_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 33);
    i0.ɵɵtemplate(1, Pagination_div_4_span_3_ng_container_1_Template, 2, 1, "ng-container", 7);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "i18nReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r14.showPageInput);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, i0.ɵɵpipeBind2(4, 4, ctx_r14.ofLastPageText.subject, i0.ɵɵpureFunction1(7, _c3, ctx_r14.lastPage))), " ");
  }
}
function Pagination_div_4_span_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r28.currentPage);
  }
}
function Pagination_div_4_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 33);
    i0.ɵɵtemplate(1, Pagination_div_4_span_4_ng_container_1_Template, 2, 1, "ng-container", 7);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "i18nReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r15.showPageInput);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, i0.ɵɵpipeBind2(4, 4, ctx_r15.ofLastPagesText.subject, i0.ɵɵpureFunction1(7, _c3, ctx_r15.lastPage))), " ");
  }
}
const _c4 = a0 => ({
  "cds--pagination__button--no-index": a0
});
function Pagination_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, Pagination_div_4_span_1_Template, 4, 4, "span", 17)(2, Pagination_div_4_ng_container_2_Template, 8, 9, "ng-container", 7)(3, Pagination_div_4_span_3_Template, 5, 9, "span", 18)(4, Pagination_div_4_span_4_Template, 5, 9, "span", 18);
    i0.ɵɵelementStart(5, "div", 19)(6, "button", 20);
    i0.ɵɵlistener("click", function Pagination_div_4_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r30);
      const ctx_r29 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r29.selectPage.emit(ctx_r29.previousPage));
    });
    i0.ɵɵpipe(7, "async");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(8, "svg", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(9, "button", 22);
    i0.ɵɵlistener("click", function Pagination_div_4_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r30);
      const ctx_r31 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r31.selectPage.emit(ctx_r31.nextPage));
    });
    i0.ɵɵpipe(10, "async");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(11, "svg", 23);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.pagesUnknown);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.showPageInput);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r3.pagesUnknown && ctx_r3.lastPage <= 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r3.pagesUnknown && ctx_r3.lastPage > 1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c4, ctx_r3.currentPage <= 1 || ctx_r3.disabled))("disabled", ctx_r3.currentPage <= 1 || ctx_r3.disabled ? true : null);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(7, 10, ctx_r3.backwardText.subject));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c4, ctx_r3.currentPage >= ctx_r3.lastPage || ctx_r3.disabled))("disabled", ctx_r3.currentPage >= ctx_r3.lastPage || ctx_r3.disabled ? true : null);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(10, 12, ctx_r3.forwardText.subject));
  }
}
const _c5 = a0 => ({
  "cds--skeleton": a0
});
const _c6 = a0 => ({
  "cds--pagination-nav__page--active": a0
});
function PaginationOverflow_li_0_option_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r4 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.fromIndex + i_r4 + 1, " ");
  }
}
function PaginationOverflow_li_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 2)(1, "div", 3)(2, "select", 4);
    i0.ɵɵlistener("change", function PaginationOverflow_li_0_Template_select_change_2_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.handleChange($event));
    });
    i0.ɵɵelement(3, "option", 5);
    i0.ɵɵtemplate(4, PaginationOverflow_li_0_option_4_Template, 2, 1, "option", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 7);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(6, "svg", 8);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", ctx_r0.ariaLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.countAsArray);
  }
}
function PaginationOverflow_cds_pagination_nav_item_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cds-pagination-nav-item", 9);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("page", ctx_r1.fromIndex + 1);
  }
}
function PaginationNav_cds_pagination_nav_item_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "cds-pagination-nav-item", 11);
    i0.ɵɵlistener("click", function PaginationNav_cds_pagination_nav_item_7_Template_cds_pagination_nav_item_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.currentPage = 1);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isActive", ctx_r0.currentPage == 1);
  }
}
function PaginationNav_cds_pagination_overflow_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "cds-pagination-overflow", 12);
    i0.ɵɵlistener("change", function PaginationNav_cds_pagination_overflow_8_Template_cds_pagination_overflow_change_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r7 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r7.handleOverflowSelection($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("count", ctx_r1.frontCuts)("fromIndex", ctx_r1.startOffset);
  }
}
function PaginationNav_cds_pagination_nav_item_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "cds-pagination-nav-item", 13);
    i0.ɵɵlistener("click", function PaginationNav_cds_pagination_nav_item_9_Template_cds_pagination_nav_item_click_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r11);
      const page_r9 = restoredCtx.$implicit;
      const ctx_r10 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r10.currentPage = page_r9);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const page_r9 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("page", page_r9)("isActive", ctx_r2.currentPage == page_r9);
  }
}
function PaginationNav_cds_pagination_overflow_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "cds-pagination-overflow", 12);
    i0.ɵɵlistener("change", function PaginationNav_cds_pagination_overflow_10_Template_cds_pagination_overflow_change_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r12 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r12.handleOverflowSelection($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("count", ctx_r3.backCuts)("fromIndex", ctx_r3.totalNumbersArray.length - ctx_r3.backCuts - 1);
  }
}
function PaginationNav_cds_pagination_nav_item_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "cds-pagination-nav-item", 13);
    i0.ɵɵlistener("click", function PaginationNav_cds_pagination_nav_item_11_Template_cds_pagination_nav_item_click_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r14 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r14.currentPage = ctx_r14.totalNumbersArray.length);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("page", ctx_r4.totalNumbersArray.length)("isActive", ctx_r4.currentPage == ctx_r4.totalNumbersArray.length);
  }
}
class PaginationModel {
  constructor() {
    /**
     * Tracks the current page.
     */
    this.currentPage = 1;
    /**
     * Length of page.
     */
    /* tslint:disable-next-line*/
    this.pageLength = 10;
    /**
     * Absolute total number of items needed to paginate.
     */
    this.totalDataLength = 0;
  }
}

/**
 * Use pagination when you have multiple pages of data to handle. Get started with importing the module:
 *
 * ```typescript
 * import { PaginationModule } from 'carbon-components-angular';
 * ```
 *
 * ```html
 *	<cds-pagination [model]="model" (selectPage)="selectPage($event)"></cds-pagination>
 * ```
 *
 * In your `selectPage()` method set the `model.currentPage` to selected page, _after_
 * you load the page.
 *
 * ```typescript
 * selectPage(page) {
 * 	// ... your code to load the page goes here
 *
 * 	this.model.currentPage = page;
 *
 * 	// ... anything you want to do after page selection changes goes here
 * }
 * ```
 *
 * [See demo](../../?path=/story/components-pagination--basic)
 */
class Pagination {
  constructor(i18n, experimental) {
    this.i18n = i18n;
    this.experimental = experimental;
    /**
     * Set to `true` for a loading pagination component.
     */
    this.skeleton = false;
    /**
     * Set to `true` to disable the backward/forward buttons.
     */
    this.disabled = false;
    /**
     * Set to `true` to disable the select box that changes the page.
     */
    this.pageInputDisabled = false;
    /**
     * Controls wether or not to show the page selects
     */
    this.showPageInput = true;
    /**
     * Set to `true` if the total number of items is unknown.
     */
    this.pagesUnknown = false;
    this.pageSelectThreshold = 1000;
    /**
     * Options for items per page select
     *
     * A default array of options will be defined: [10, 20, 30, 40, 50]
     */
    this.itemsPerPageOptions = [10, 20, 30, 40, 50];
    /**
     * Emits the new page number.
     *
     * You should tie into this and update `model.currentPage` once the fresh
     * data is finally loaded.
     */
    this.selectPage = new EventEmitter();
    this.itemsPerPageSelectId = `pagination-select-items-per-page-${Pagination.paginationCounter}`;
    this.currentPageSelectId = `pagination-select-current-page-${Pagination.paginationCounter}`;
    this.itemsPerPageText = this.i18n.getOverridable("PAGINATION.ITEMS_PER_PAGE");
    this.optionsListText = this.i18n.getOverridable("PAGINATION.OPEN_LIST_OF_OPTIONS");
    this.backwardText = this.i18n.getOverridable("PAGINATION.BACKWARD");
    this.forwardText = this.i18n.getOverridable("PAGINATION.FORWARD");
    this.totalItemsText = this.i18n.getOverridable("PAGINATION.TOTAL_ITEMS");
    this.totalItemText = this.i18n.getOverridable("PAGINATION.TOTAL_ITEM");
    this.totalItemsUnknownText = this.i18n.getOverridable("PAGINATION.TOTAL_ITEMS_UNKNOWN");
    this.pageText = this.i18n.getOverridable("PAGINATION.PAGE");
    this.ofLastPagesText = this.i18n.getOverridable("PAGINATION.OF_LAST_PAGES");
    this.ofLastPageText = this.i18n.getOverridable("PAGINATION.OF_LAST_PAGE");
    this._pageOptions = [];
    Pagination.paginationCounter++;
  }
  /**
   * Expects an object that contains some or all of:
   * ```
   * {
   *		"ITEMS_PER_PAGE": "Items per page:",
   *		"OPEN_LIST_OF_OPTIONS": "Open list of options",
   *		"BACKWARD": "Backward",
   *		"FORWARD": "Forward",
   *		"TOTAL_ITEMS_UNKNOWN": "{{start}}-{{end}} items",
   *		"TOTAL_ITEMS": "{{start}}-{{end}} of {{total}} items",
   *		"TOTAL_ITEM": "{{start}}-{{end}} of {{total}} item",
   *		"OF_LAST_PAGES": "of {{last}} pages",
   *		"OF_LAST_PAGE": "of {{last}} page"
   * }
   * ```
   */
  set translations(value) {
    const valueWithDefaults = merge(this.i18n.getMultiple("PAGINATION"), value);
    this.itemsPerPageText.override(valueWithDefaults.ITEMS_PER_PAGE);
    this.optionsListText.override(valueWithDefaults.OPEN_LIST_OF_OPTIONS);
    this.backwardText.override(valueWithDefaults.BACKWARD);
    this.forwardText.override(valueWithDefaults.FORWARD);
    this.totalItemsText.override(valueWithDefaults.TOTAL_ITEMS);
    this.totalItemText.override(valueWithDefaults.TOTAL_ITEM);
    this.totalItemsUnknownText.override(valueWithDefaults.TOTAL_ITEMS_UNKNOWN);
    this.pageText.override(valueWithDefaults.PAGE);
    this.ofLastPagesText.override(valueWithDefaults.OF_LAST_PAGES);
    this.ofLastPageText.override(valueWithDefaults.OF_LAST_PAGE);
  }
  get itemsPerPage() {
    return this.model.pageLength;
  }
  set itemsPerPage(value) {
    this.model.pageLength = Number(value);
    this.currentPage = 1; // reset page
  }
  get currentPage() {
    return this.model.currentPage;
  }
  set currentPage(value) {
    value = Number(value);
    // emits the value to allow the user to update current page
    // in the model once the page is loaded
    this.selectPage.emit(value);
  }
  get totalDataLength() {
    return this.model.totalDataLength;
  }
  /**
   * The last page number to display in the pagination view.
   */
  get lastPage() {
    const last = Math.ceil(this.totalDataLength / this.itemsPerPage);
    return last > 0 ? last : 1;
  }
  get startItemIndex() {
    return this.endItemIndex > 0 ? (this.currentPage - 1) * this.itemsPerPage + 1 : 0;
  }
  get endItemIndex() {
    const projectedEndItemIndex = this.currentPage * this.itemsPerPage;
    return projectedEndItemIndex < this.totalDataLength ? projectedEndItemIndex : this.totalDataLength;
  }
  /**
   * The previous page number to navigate to, from the current page.
   */
  get previousPage() {
    return this.currentPage <= 1 ? 1 : this.currentPage - 1;
  }
  /**
   * The next page number to navigate to, from the current page.
   */
  get nextPage() {
    const lastPage = this.lastPage;
    return this.currentPage >= lastPage ? lastPage : this.currentPage + 1;
  }
  get pageOptions() {
    if (this.totalDataLength && this._pageOptions.length !== this.totalDataLength) {
      this._pageOptions = Array(Math.ceil(this.totalDataLength / this.itemsPerPage));
    }
    return this._pageOptions;
  }
}
Pagination.paginationCounter = 0;
Pagination.ɵfac = function Pagination_Factory(t) {
  return new (t || Pagination)(i0.ɵɵdirectiveInject(i1.I18n), i0.ɵɵdirectiveInject(i2.ExperimentalService));
};
Pagination.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: Pagination,
  selectors: [["cds-pagination"], ["ibm-pagination"]],
  inputs: {
    skeleton: "skeleton",
    model: "model",
    disabled: "disabled",
    pageInputDisabled: "pageInputDisabled",
    showPageInput: "showPageInput",
    pagesUnknown: "pagesUnknown",
    pageSelectThreshold: "pageSelectThreshold",
    translations: "translations",
    itemsPerPageOptions: "itemsPerPageOptions"
  },
  outputs: {
    selectPage: "selectPage"
  },
  decls: 5,
  vars: 7,
  consts: [[1, "cds--pagination", 3, "ngClass"], ["class", "cds--pagination__left", 4, "ngIf"], ["class", "cds--pagination__right", 4, "ngIf"], [1, "cds--pagination__left"], [1, "cds--skeleton__text", 2, "width", "70px"], [1, "cds--skeleton__text", 2, "width", "35px"], [1, "cds--skeleton__text", 2, "width", "105px"], [4, "ngIf"], ["class", "cds--pagination__text cds--pagination__items-count", 3, "ngStyle", 4, "ngIf"], [1, "cds--pagination__text", 3, "for"], [1, "cds--select", "cds--select--inline", "cds--select__item-count"], [1, "cds--select-input", 3, "id", "ngModel", "disabled", "ngModelChange"], ["class", "cds--select-option", 3, "value", 4, "ngFor", "ngForOf"], ["cdsIcon", "chevron--down", "size", "16", "aria-hidden", "true", 1, "cds--select__arrow", 2, "display", "inherit"], [1, "cds--select-option", 3, "value"], [1, "cds--pagination__text", "cds--pagination__items-count", 3, "ngStyle"], [1, "cds--pagination__right"], ["class", "cds--pagination__text cds--pagination__page-text", 4, "ngIf"], ["class", "cds--pagination__text", 4, "ngIf"], [1, "cds--pagination__control-buttons"], ["cdsButton", "ghost", "iconOnly", "true", "tabindex", "0", 1, "cds--pagination__button", "cds--pagination__button--backward", 3, "ngClass", "disabled", "click"], ["cdsIcon", "caret--left", "size", "16", 1, "cds--btn__icon"], ["cdsButton", "ghost", "iconOnly", "true", "tabindex", "0", 1, "cds--pagination__button", "cds--pagination__button--forward", 3, "ngClass", "disabled", "click"], ["cdsIcon", "caret--right", "size", "16", 1, "cds--btn__icon"], [1, "cds--pagination__text", "cds--pagination__page-text"], [1, "cds--select", "cds--select--inline", "cds--select__page-number"], [1, "cds--label", "cds--visually-hidden", 3, "for"], ["style", "padding-right: 1rem; margin-right: 1rem;", "type", "number", "min", "1", "class", "cds--select-input", 3, "id", "max", "ngModel", "ngModelChange", 4, "ngIf"], ["class", "cds--select-input", 3, "id", "disabled", "ngModel", "ngModelChange", 4, "ngIf"], ["cdsIcon", "chevron--down", "size", "16", "style", "display: inherit;", "class", "cds--select__arrow", 4, "ngIf"], ["type", "number", "min", "1", 1, "cds--select-input", 2, "padding-right", "1rem", "margin-right", "1rem", 3, "id", "max", "ngModel", "ngModelChange"], [1, "cds--select-input", 3, "id", "disabled", "ngModel", "ngModelChange"], ["cdsIcon", "chevron--down", "size", "16", 1, "cds--select__arrow", 2, "display", "inherit"], [1, "cds--pagination__text"]],
  template: function Pagination_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "div", 0);
      i0.ɵɵtemplate(1, Pagination_div_1_Template, 4, 0, "div", 1)(2, Pagination_div_2_Template, 5, 4, "div", 1)(3, Pagination_div_3_Template, 2, 0, "div", 2)(4, Pagination_div_4_Template, 12, 18, "div", 2);
      i0.ɵɵelementEnd();
    }
    if (rf & 2) {
      i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c5, ctx.skeleton));
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", ctx.skeleton);
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", !ctx.skeleton);
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", ctx.skeleton);
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", !ctx.skeleton);
    }
  },
  dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgStyle, i4.NgSelectOption, i4.ɵNgSelectMultipleOption, i4.DefaultValueAccessor, i4.NumberValueAccessor, i4.SelectControlValueAccessor, i4.NgControlStatus, i4.MinValidator, i4.MaxValidator, i4.NgModel, i4$1.IconDirective, i6.Button, i3.AsyncPipe, i1.ReplacePipe],
  encapsulation: 2
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Pagination, [{
    type: Component,
    args: [{
      selector: "cds-pagination, ibm-pagination",
      template: `
	<div
		class="cds--pagination"
		[ngClass]="{
			'cds--skeleton': skeleton
		}">
		<!-- left skeleton div -->
		<div *ngIf="skeleton" class="cds--pagination__left">
			<p class="cds--skeleton__text" style="width: 70px"></p>
			<p class="cds--skeleton__text" style="width: 35px"></p>
			<p class="cds--skeleton__text" style="width: 105px"></p>
		</div>

		<div *ngIf="!skeleton" class="cds--pagination__left">
			<ng-container *ngIf="showPageInput">
				<label class="cds--pagination__text" [for]="itemsPerPageSelectId">
					{{itemsPerPageText.subject | async}}
				</label>
				<div
					class="cds--select cds--select--inline cds--select__item-count"
					[class.cds--select--disabled]="pageInputDisabled">
					<select
						[id]="itemsPerPageSelectId"
						[(ngModel)]="itemsPerPage"
						[disabled]="pageInputDisabled"
						class="cds--select-input">
						<option
							class="cds--select-option"
							*ngFor="let option of itemsPerPageOptions"
							[value]="option">
								{{ option }}
						</option>
					</select>
					<svg
						cdsIcon="chevron--down"
						size="16"
						style="display: inherit"
						class="cds--select__arrow"
						aria-hidden="true"
						[attr.ariaLabel]="optionsListText.subject | async">
					</svg>
				</div>
			</ng-container>
			<span *ngIf="!pagesUnknown && totalDataLength <= 1" class="cds--pagination__text cds--pagination__items-count" [ngStyle]="{'margin-left': showPageInput ? null : 0}">
				{{totalItemText.subject | i18nReplace:{start: startItemIndex, end: endItemIndex, total: totalDataLength } | async}}
			</span>
			<span *ngIf="!pagesUnknown && totalDataLength > 1" class="cds--pagination__text cds--pagination__items-count" [ngStyle]="{'margin-left': showPageInput ? null : 0}">
				{{totalItemsText.subject | i18nReplace:{start: startItemIndex, end: endItemIndex, total: totalDataLength } | async}}
			</span>
			<span *ngIf="pagesUnknown" class="cds--pagination__text cds--pagination__items-count" [ngStyle]="{'margin-left': showPageInput ? null : 0}">
				{{totalItemsUnknownText.subject | i18nReplace:{start: startItemIndex, end: endItemIndex } | async}}
			</span>
		</div>

		<!-- right skeleton div -->
		<div *ngIf="skeleton" class="cds--pagination__right">
			<p class="cds--skeleton__text" style="width: 70px"></p>
		</div>

		<div *ngIf="!skeleton" class="cds--pagination__right">
			<span *ngIf="pagesUnknown" class="cds--pagination__text cds--pagination__page-text">
				<ng-container *ngIf="!showPageInput">{{currentPage}}</ng-container>
				{{pageText.subject | async}}
			</span>
			<ng-container *ngIf="showPageInput">
				<div
					class="cds--select cds--select--inline cds--select__page-number"
					[class.cds--select--disabled]="pageInputDisabled">
					<label [for]="currentPageSelectId" class="cds--label cds--visually-hidden">{{pageText.subject | async}}</label>
					<input
						*ngIf="pageOptions.length > pageSelectThreshold"
						style="padding-right: 1rem; margin-right: 1rem;"
						[id]="currentPageSelectId"
						type="number"
						min="1"
						[max]="pageOptions.length"
						class="cds--select-input"
						[(ngModel)]="currentPage">
					<select
						*ngIf="pageOptions.length <= pageSelectThreshold"
						[id]="currentPageSelectId"
						class="cds--select-input"
						[disabled]="pageInputDisabled"
						[(ngModel)]="currentPage">
						<option *ngFor="let page of pageOptions; let i = index;" class="cds--select-option" [value]="i + 1">{{i + 1}}</option>
					</select>
					<svg
						*ngIf="pageOptions.length <= 1000"
						cdsIcon="chevron--down"
						size="16"
						style="display: inherit;"
						class="cds--select__arrow"
						[attr.ariaLabel]="optionsListText.subject | async">
					</svg>
				</div>
			</ng-container>

			<span *ngIf="!pagesUnknown && lastPage <= 1" class="cds--pagination__text">
				<ng-container *ngIf="!showPageInput">{{currentPage}}</ng-container>
				{{ofLastPageText.subject | i18nReplace: {last: lastPage} | async}}
			</span>
			<span *ngIf="!pagesUnknown && lastPage > 1" class="cds--pagination__text">
				<ng-container *ngIf="!showPageInput">{{currentPage}}</ng-container>
				{{ofLastPagesText.subject | i18nReplace: {last: lastPage} | async}}
			</span>
			<div class="cds--pagination__control-buttons">
				<button
					cdsButton="ghost"
					iconOnly="true"
					class="cds--pagination__button cds--pagination__button--backward"
					[ngClass]="{
						'cds--pagination__button--no-index': currentPage <= 1 || disabled
					}"
					tabindex="0"
					[attr.aria-label]="backwardText.subject | async"
					(click)="selectPage.emit(previousPage)"
					[disabled]="(currentPage <= 1 || disabled ? true : null)">
					<svg cdsIcon="caret--left" size="16" class="cds--btn__icon"></svg>
				</button>

				<button
					cdsButton="ghost"
					iconOnly="true"
					class="
						cds--pagination__button
						cds--pagination__button--forward"
					[ngClass]="{
						'cds--pagination__button--no-index': currentPage >= lastPage || disabled
					}"
					tabindex="0"
					[attr.aria-label]="forwardText.subject | async"
					(click)="selectPage.emit(nextPage)"
					[disabled]="(currentPage >= lastPage || disabled ? true : null)">
					<svg cdsIcon="caret--right" size="16" class="cds--btn__icon"></svg>
				</button>
			</div>
		</div>
	</div>
	`
    }]
  }], function () {
    return [{
      type: i1.I18n
    }, {
      type: i2.ExperimentalService
    }];
  }, {
    skeleton: [{
      type: Input
    }],
    model: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    pageInputDisabled: [{
      type: Input
    }],
    showPageInput: [{
      type: Input
    }],
    pagesUnknown: [{
      type: Input
    }],
    pageSelectThreshold: [{
      type: Input
    }],
    translations: [{
      type: Input
    }],
    itemsPerPageOptions: [{
      type: Input
    }],
    selectPage: [{
      type: Output
    }]
  });
})();

/**
 * Used to present a single navigation item in a pagination list
 *
 *  * ```html
 * <cds-pagination-nav-item [page]="5" [isActive]="false" (click)="handleClick(value)"></cds-pagination-nav-item>
 * ```
 */
class PaginationNavItem {
  constructor() {
    /**
     * The page for this component to dipslay
     */
    this.page = 0;
    /**
     * The state for this component to dipslay
     */
    this.isActive = false;
    /**
     * Emits click event
     */
    this.click = new EventEmitter();
  }
}
PaginationNavItem.ɵfac = function PaginationNavItem_Factory(t) {
  return new (t || PaginationNavItem)();
};
PaginationNavItem.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: PaginationNavItem,
  selectors: [["cds-pagination-nav-item"], ["ibm-pagination-nav-item"]],
  inputs: {
    page: "page",
    isActive: "isActive"
  },
  outputs: {
    click: "click"
  },
  decls: 5,
  vars: 5,
  consts: [[1, "cds--pagination-nav__list-item"], ["type", "button", 1, "cds--pagination-nav__page", 3, "ngClass", "click"], [1, "cds--pagination-nav__accessibility-label"]],
  template: function PaginationNavItem_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "li", 0)(1, "button", 1);
      i0.ɵɵlistener("click", function PaginationNavItem_Template_button_click_1_listener() {
        return ctx.click.emit(ctx.page);
      });
      i0.ɵɵelementStart(2, "span", 2);
      i0.ɵɵtext(3);
      i0.ɵɵelementEnd();
      i0.ɵɵtext(4);
      i0.ɵɵelementEnd()();
    }
    if (rf & 2) {
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c6, ctx.isActive));
      i0.ɵɵadvance(2);
      i0.ɵɵtextInterpolate1(" ", ctx.page, " ");
      i0.ɵɵadvance();
      i0.ɵɵtextInterpolate1(" ", ctx.page, " ");
    }
  },
  dependencies: [i3.NgClass],
  encapsulation: 2
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationNavItem, [{
    type: Component,
    args: [{
      selector: "cds-pagination-nav-item, ibm-pagination-nav-item",
      template: `
		<li class="cds--pagination-nav__list-item">
			<button
				type="button"
				class="cds--pagination-nav__page"
				[ngClass]="{ 'cds--pagination-nav__page--active': isActive }"
				(click)="click.emit(page)">
				<span class="cds--pagination-nav__accessibility-label">
					{{page}}
				</span>
				{{page}}
			</button>
		</li>
	`
    }]
  }], function () {
    return [];
  }, {
    page: [{
      type: Input
    }],
    isActive: [{
      type: Input
    }],
    click: [{
      type: Output
    }]
  });
})();

/**
 * Used to present a selection of pages when there is an overflow
 * in the pagination list
 *
 * * ```html
 * <cds-pagination-overflow [fromIndex]="5" [count]="30" (change)="handleChange(value)"></cds-pagination-overflow>
 * ```
 */
class PaginationOverflow {
  constructor(i18n) {
    this.i18n = i18n;
    this.ariaLabel = this.i18n.get().PAGINATION.SELECT_ARIA;
    /**
     * Emits click event
     */
    this.change = new EventEmitter();
  }
  get countAsArray() {
    return [...Array(this.count)];
  }
  handleChange(event) {
    this.change.emit(+event.target.value);
    event.target.value = "";
  }
}
PaginationOverflow.ɵfac = function PaginationOverflow_Factory(t) {
  return new (t || PaginationOverflow)(i0.ɵɵdirectiveInject(i1.I18n));
};
PaginationOverflow.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: PaginationOverflow,
  selectors: [["cds-pagination-overflow"], ["ibm-pagination-overflow"]],
  inputs: {
    fromIndex: "fromIndex",
    count: "count",
    ariaLabel: "ariaLabel"
  },
  outputs: {
    change: "change"
  },
  decls: 2,
  vars: 2,
  consts: [["class", "cds--pagination-nav__list-item", 4, "ngIf"], [3, "page", 4, "ngIf"], [1, "cds--pagination-nav__list-item"], [1, "cds--pagination-nav__select"], [1, "cds--pagination-nav__page", "cds--pagination-nav__page--select", 3, "change"], ["value", "", "hidden", ""], [4, "ngFor", "ngForOf"], [1, "cds--pagination-nav__select-icon-wrapper"], ["cdsIcon", "overflow-menu--horizontal", "size", "16", 1, "cds--pagination-nav__select-icon", 2, "display", "inherit"], [3, "page"]],
  template: function PaginationOverflow_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵtemplate(0, PaginationOverflow_li_0_Template, 7, 2, "li", 0)(1, PaginationOverflow_cds_pagination_nav_item_1_Template, 1, 1, "cds-pagination-nav-item", 1);
    }
    if (rf & 2) {
      i0.ɵɵproperty("ngIf", ctx.count > 1);
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", ctx.count === 1);
    }
  },
  dependencies: [i3.NgForOf, i3.NgIf, i4.NgSelectOption, i4.ɵNgSelectMultipleOption, i4$1.IconDirective, PaginationNavItem],
  encapsulation: 2
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationOverflow, [{
    type: Component,
    args: [{
      selector: "cds-pagination-overflow, ibm-pagination-overflow",
      template: `
		<li class="cds--pagination-nav__list-item" *ngIf="count > 1">
			<div class="cds--pagination-nav__select">
			<select
				[attr.aria-label]="ariaLabel"
				class="cds--pagination-nav__page cds--pagination-nav__page--select"
				(change)="handleChange($event)">
				<option value="" hidden></option>
				<option
				*ngFor="let item of countAsArray; let i = index">
					{{fromIndex + i + 1}}
				</option>
			</select>
			<div class="cds--pagination-nav__select-icon-wrapper">
				<svg
					cdsIcon="overflow-menu--horizontal"
					size="16"
					style="display: inherit"
					class="cds--pagination-nav__select-icon">
				</svg>
			</div>
			</div>
		</li>
		<cds-pagination-nav-item *ngIf="count === 1" [page]="fromIndex + 1"></cds-pagination-nav-item>
	`
    }]
  }], function () {
    return [{
      type: i1.I18n
    }];
  }, {
    fromIndex: [{
      type: Input
    }],
    count: [{
      type: Input
    }],
    ariaLabel: [{
      type: Input
    }],
    change: [{
      type: Output
    }]
  });
})();

/**
 * Use pagination when you have multiple pages of data to handle. Get started with importing the module:
 *
 * ```typescript
 * import { PaginationModule } from 'carbon-components-angular';
 * ```
 *
 * ```html
 * <cds-pagination-nav [model]="model" (selectPage)="selectPage($event)"></cds-pagination-nav>
 * ```
 *
 * In your `selectPage()` method set the `model.currentPage` to selected page, _after_
 * you load the page.
 *
 * ```typescript
 * selectPage(page) {
 * 	// ... your code to load the page goes here
 *
 * 	this.model.currentPage = page;
 *
 * 	// ... anything you want to do after page selection changes goes here
 * }
 * ```
 *
 * [See demo](../../?path=/story/components-pagination-nav--basic)
 */
class PaginationNav {
  constructor(i18n, experimental) {
    this.i18n = i18n;
    this.experimental = experimental;
    /**
       * Set to `true` to disable the backward/forward buttons.
     */
    this.disabled = false;
    /**
     * Number of items to show in pagination. Minimum is 4.
     */
    this.numOfItemsToShow = 4;
    /**
     * Emits the new page number.
     *
     * You should tie into this and update `model.currentPage` once the fresh
     * data is finally loaded.
     */
    this.selectPage = new EventEmitter();
    this.nextItemText = this.i18n.getOverridable("PAGINATION.NEXT");
    this.previousItemText = this.i18n.getOverridable("PAGINATION.PREVIOUS");
    PaginationNav.paginationCounter++;
  }
  /**
   * Expects an object that contains some or all of:
   * ```
   * {
   *		"NEXT": "Next",
   *		"PREVIOUS": "Previous",
   * }
   * ```
   */
  set translations(value) {
    const valueWithDefaults = merge(this.i18n.getMultiple("PAGINATION"), value);
    this.nextItemText.override(valueWithDefaults.NEXT);
    this.previousItemText.override(valueWithDefaults.PREVIOUS);
  }
  get totalNumbersArray() {
    return range(this.totalDataLength + 1, 1);
  }
  get currentPage() {
    return this.model.currentPage;
  }
  set currentPage(value) {
    value = Number(value);
    // emits the value to allow the user to update current page
    // in the model once the page is loaded
    this.selectPage.emit(value);
  }
  get totalDataLength() {
    return this.model.totalDataLength;
  }
  get startOffset() {
    return this.numOfItemsToShow <= 4 && this.currentPage > 1 ? 0 : 1;
  }
  get frontCuts() {
    const cuts = this.getCuts();
    return cuts.front;
  }
  get backCuts() {
    const cuts = this.getCuts();
    return cuts.back;
  }
  get leftArrowDisabled() {
    return this.disabled || this.currentPage === 1;
  }
  get rightArrowDisabled() {
    return this.disabled || this.currentPage === this.totalDataLength;
  }
  handleOverflowSelection(page) {
    if (typeof page === "number") {
      this.currentPage = page;
    }
  }
  jumpToNext() {
    this.currentPage = this.currentPage < this.totalDataLength ? this.currentPage + 1 : this.totalDataLength;
  }
  jumpToPrevious() {
    this.currentPage = this.currentPage > 1 ? this.currentPage - 1 : 1;
  }
  getPages() {
    if (this.totalDataLength <= 1) {
      return null;
    }
    const cuts = this.getCuts();
    return this.totalNumbersArray.slice(this.startOffset + cuts.front, (1 + cuts.back) * -1);
  }
  getCuts(splitPoint = null) {
    const page = this.currentPage - 1;
    const totalItems = this.totalDataLength;
    const itemsThatFit = this.numOfItemsToShow;
    if (itemsThatFit >= totalItems) {
      return {
        front: 0,
        back: 0
      };
    }
    const split = splitPoint || Math.ceil(itemsThatFit / 2) - 1;
    let frontHidden = page + 1 - split;
    let backHidden = totalItems - page - (itemsThatFit - split) + 1;
    if (frontHidden <= 1) {
      backHidden -= frontHidden <= 0 ? Math.abs(frontHidden) + 1 : 0;
      frontHidden = 0;
    }
    if (backHidden <= 1) {
      frontHidden -= backHidden <= 0 ? Math.abs(backHidden) + 1 : 0;
      backHidden = 0;
    }
    return {
      front: frontHidden,
      back: backHidden
    };
  }
}
PaginationNav.paginationCounter = 0;
PaginationNav.ɵfac = function PaginationNav_Factory(t) {
  return new (t || PaginationNav)(i0.ɵɵdirectiveInject(i1.I18n), i0.ɵɵdirectiveInject(i2.ExperimentalService));
};
PaginationNav.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: PaginationNav,
  selectors: [["cds-pagination-nav"], ["ibm-pagination-navm"]],
  inputs: {
    model: "model",
    disabled: "disabled",
    numOfItemsToShow: "numOfItemsToShow",
    translations: "translations"
  },
  outputs: {
    selectPage: "selectPage"
  },
  decls: 16,
  vars: 13,
  consts: [[1, "cds--pagination-nav"], [1, "cds--pagination-nav__list"], [1, "cds--pagination-nav__list-item"], ["kind", "ghost", "size", "md", 3, "disabled", "description", "click"], ["cdsIcon", "caret--left", "size", "16", 1, "cds--btn__icon"], ["page", "1", 3, "isActive", "click", 4, "ngIf"], [3, "count", "fromIndex", "change", 4, "ngIf"], [3, "page", "isActive", "click", 4, "ngFor", "ngForOf"], [3, "page", "isActive", "click", 4, "ngIf"], ["kind", "ghost", 3, "disabled", "description", "click"], ["cdsIcon", "caret--right", "size", "16", 1, "cds--btn__icon"], ["page", "1", 3, "isActive", "click"], [3, "count", "fromIndex", "change"], [3, "page", "isActive", "click"]],
  template: function PaginationNav_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "div")(1, "div", 0)(2, "ul", 1)(3, "li", 2)(4, "cds-icon-button", 3);
      i0.ɵɵlistener("click", function PaginationNav_Template_cds_icon_button_click_4_listener() {
        return ctx.jumpToPrevious();
      });
      i0.ɵɵpipe(5, "async");
      i0.ɵɵnamespaceSVG();
      i0.ɵɵelement(6, "svg", 4);
      i0.ɵɵelementEnd()();
      i0.ɵɵtemplate(7, PaginationNav_cds_pagination_nav_item_7_Template, 1, 1, "cds-pagination-nav-item", 5)(8, PaginationNav_cds_pagination_overflow_8_Template, 1, 2, "cds-pagination-overflow", 6)(9, PaginationNav_cds_pagination_nav_item_9_Template, 1, 2, "cds-pagination-nav-item", 7)(10, PaginationNav_cds_pagination_overflow_10_Template, 1, 2, "cds-pagination-overflow", 6)(11, PaginationNav_cds_pagination_nav_item_11_Template, 1, 2, "cds-pagination-nav-item", 8);
      i0.ɵɵnamespaceHTML();
      i0.ɵɵelementStart(12, "li", 2)(13, "cds-icon-button", 9);
      i0.ɵɵlistener("click", function PaginationNav_Template_cds_icon_button_click_13_listener() {
        return ctx.jumpToNext();
      });
      i0.ɵɵpipe(14, "async");
      i0.ɵɵnamespaceSVG();
      i0.ɵɵelement(15, "svg", 10);
      i0.ɵɵelementEnd()()()()();
    }
    if (rf & 2) {
      i0.ɵɵadvance(4);
      i0.ɵɵproperty("disabled", ctx.leftArrowDisabled)("description", i0.ɵɵpipeBind1(5, 9, ctx.previousItemText.subject));
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("ngIf", ctx.numOfItemsToShow >= 5 || ctx.numOfItemsToShow <= 4 && ctx.currentPage <= 1);
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", ctx.frontCuts);
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngForOf", ctx.getPages());
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", ctx.backCuts);
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", ctx.totalDataLength > 1);
      i0.ɵɵadvance(2);
      i0.ɵɵproperty("disabled", ctx.rightArrowDisabled)("description", i0.ɵɵpipeBind1(14, 11, ctx.nextItemText.subject));
    }
  },
  dependencies: [i3.NgForOf, i3.NgIf, i4$1.IconDirective, i6.IconButton, PaginationNavItem, PaginationOverflow, i3.AsyncPipe],
  encapsulation: 2
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationNav, [{
    type: Component,
    args: [{
      selector: "cds-pagination-nav, ibm-pagination-navm",
      template: `
	<div>
		<div class="cds--pagination-nav">
			<ul class="cds--pagination-nav__list">
				<li class="cds--pagination-nav__list-item">
					<cds-icon-button
						kind="ghost"
						size="md"
						(click)="jumpToPrevious()"
						[disabled]="leftArrowDisabled"
						[description]="previousItemText.subject | async">
						<svg
							cdsIcon="caret--left"
							size="16"
							class="cds--btn__icon">
						</svg>
					</cds-icon-button>
				</li>
				<cds-pagination-nav-item
					*ngIf="this.numOfItemsToShow >= 5 || (this.numOfItemsToShow <= 4 && currentPage <= 1)"
					page="1"
					(click)="currentPage = 1"
					[isActive]="currentPage == 1">
				</cds-pagination-nav-item>
				<cds-pagination-overflow
					*ngIf="frontCuts"
					[count]="frontCuts"
					[fromIndex]="startOffset"
					(change)="handleOverflowSelection($event)">
				</cds-pagination-overflow>
				<cds-pagination-nav-item
					*ngFor="let page of getPages();"
					[page]="page"
					(click)="currentPage = page"
					[isActive]="currentPage == page">
				</cds-pagination-nav-item>
				<cds-pagination-overflow
					*ngIf="backCuts"
					[count]="backCuts"
					[fromIndex]="totalNumbersArray.length - backCuts - 1"
					(change)="handleOverflowSelection($event)">
				</cds-pagination-overflow>
				<cds-pagination-nav-item
					*ngIf="totalDataLength > 1"
					[page]="totalNumbersArray.length"
					(click)="currentPage = totalNumbersArray.length"
					[isActive]="currentPage == totalNumbersArray.length">
				</cds-pagination-nav-item>
				<li class="cds--pagination-nav__list-item">
					<cds-icon-button
						kind="ghost"
						(click)="jumpToNext()"
						[disabled]="rightArrowDisabled"
						[description]="nextItemText.subject | async">
						<svg
							cdsIcon="caret--right"
							size="16"
							class="cds--btn__icon">
						</svg>
					</cds-icon-button>
				</li>
			</ul>
		</div>
	</div>
	`
    }]
  }], function () {
    return [{
      type: i1.I18n
    }, {
      type: i2.ExperimentalService
    }];
  }, {
    model: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    numOfItemsToShow: [{
      type: Input
    }],
    translations: [{
      type: Input
    }],
    selectPage: [{
      type: Output
    }]
  });
})();
class PaginationModule {}
PaginationModule.ɵfac = function PaginationModule_Factory(t) {
  return new (t || PaginationModule)();
};
PaginationModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
  type: PaginationModule
});
PaginationModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
  imports: [CommonModule, FormsModule, I18nModule, ExperimentalModule, IconModule, ButtonModule]
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationModule, [{
    type: NgModule,
    args: [{
      declarations: [Pagination, PaginationNav, PaginationNavItem, PaginationOverflow],
      exports: [Pagination, PaginationNav, PaginationNavItem, PaginationOverflow],
      imports: [CommonModule, FormsModule, I18nModule, ExperimentalModule, IconModule, ButtonModule]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Pagination, PaginationModel, PaginationModule, PaginationNav, PaginationNavItem, PaginationOverflow };
